// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"484":"84894ca0","650":"dcab35db"}[chunkId] + ".css";
};